import { useState } from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { mockDailyScans } from "@/mocks/statistics";

const tabs = ["Günlük", "Haftalık", "Aylık"];

interface Props {
  dailyScans?: { date: string; scans: number }[];
}

export default function ScanChart({ dailyScans }: Props) {
  const [activeTab, setActiveTab] = useState(0);
  const data = dailyScans && dailyScans.length > 0 ? dailyScans : mockDailyScans;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-bold text-gray-900">Tarama Grafiği</h3>
        <div className="flex gap-1 bg-gray-50 rounded-xl p-1">
          {tabs.map((tab, idx) => (
            <button
              key={tab}
              onClick={() => setActiveTab(idx)}
              className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeTab === idx ? "bg-white text-gray-900" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="scanGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10b981" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
          <Tooltip
            contentStyle={{ borderRadius: "12px", border: "1px solid #e5e7eb", fontSize: "12px" }}
            labelStyle={{ fontWeight: "bold", color: "#111827" }}
          />
          <Area
            type="monotone"
            dataKey="scans"
            stroke="#10b981"
            strokeWidth={2.5}
            fill="url(#scanGradient)"
            name="Tarama"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}